<template>
  <div>
    <section role="modal">
      <div
        class="modal fade"
        id="finalizaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="finalizaModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="finalizaModalLabel">
                Finalizar Avaliação
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Você concorda com o resultado da sua avaliação?
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                tipo="button"
                estilo="cheio-cinza"
                rotulo="Cancelar"
                icone="cancela-modal"
                dismiss="modal"
              >
              </botao>
              <botao
                tipo="button"
                estilo="vazado-verde"
                rotulo="Não"
                icone="fa-times fa-lg"
                @clicado="discorda()"
              >
              </botao>
              <botao
                tipo="button"
                estilo="cheio-verde"
                rotulo="Sim"
                icone="ok-modal"
                @clicado="concorda()"
              >
              </botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>Funcionário&nbsp;<small>(Avaliado)</small></h4>
                <div class="row">
                  <div class="form-group col-lg-4 col-md-4 col-sm-4">
                    <label>Nome:</label>
                    <p>{{ avaliacao.avaliado.pessoa.nome }}</p>
                  </div>
                  <div class="form-group col-lg-1 col-md-1 col-sm-1">
                    <label>Registro:</label>
                    <p>{{ avaliacao.avaliado.registroFormatado }}</p>
                  </div>
                  <div class="form-group col-lg-2 col-md-2 col-sm-2">
                    <label>Cargo:</label>
                    <p>{{ avaliacao.avaliado.cargoPrincipal }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Período Avaliado:</label>
                    <p>{{ peridoAvaliacao }}</p>
                  </div>
                  <div class="form-group col-lg-2 col-md-2 col-sm-2">
                    <label>Número da Avaliação:</label>
                    <p>{{ avaliacao.numeroSequenciaAvaliacao }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Chefe Imediato&nbsp;<small>(Avaliador 1)</small></h4>
                <div class="row" v-if="avaliacao.avaliador">
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <label>Nome:</label>
                    <p>{{ avaliacao.avaliador.pessoa.nome }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Registro:</label>
                    <p>{{ avaliacao.avaliador.registroFormatado }}</p>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <p>Não existe avaliador cadastrado!</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Chefe Imediato&nbsp;<small>(Avaliador 2)</small></h4>
                <div class="row" v-if="avaliacao.segundoAvaliador">
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <label>Nome:</label>
                    <p>{{ avaliacao.segundoAvaliador.pessoa.nome }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Registro:</label>
                    <p>{{ avaliacao.segundoAvaliador.registroFormatado }}</p>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <p>Não existe avaliador cadastrado!</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Avaliação de Ficha Funcional&nbsp;<small
                    >(Preenchido pelo DEGEPAT)</small
                  >
                </h4>
                <div>
                  <b>Deduções&nbsp;</b>
                  <table
                    class="table table-striped table-condensed hidden-xs"
                  >
                    <thead>
                      <tr>
                        <th align="left"><span>Atrasos</span></th>
                        <th align="left"><span>Faltas</span></th>
                        <th align="left"><span>Repreensões</span></th>
                        <th align="left"><span>Suspensões</span></th>
                        <th align="left"><span>Pontuação (A)</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-title="Atrasos" align="left">
                          (1 ponto por atraso)
                        </td>
                        <td data-title="Faltas" align="left">
                          (3 pontos por falta)
                        </td>
                        <td data-title="Repreensões" align="left">
                          (5 pontos por Repreensão)
                        </td>
                        <td data-title="Suspensões" align="left">
                          (10 pontos por Suspensão)
                        </td>
                        <td data-title="Pontuação (A)" align="left">
                          {{ avaliacao.notaFichaFuncional }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                      class="table table-striped table-condensed visible-xs"
                    >
                      <tbody>
                        <tr>
                          <td>Atrasos</td>
                          <td>(1 ponto por atraso)</td>
                        </tr>
                        <tr>
                          <td>Faltas</td>
                          <td>(3 pontos por falta)</td>
                        </tr>
                        <tr>
                          <td>Repreensões</td>
                          <td>(5 pontos por Repreensão)</td>
                        </tr>
                        <tr>
                          <td>Suspensões</td>
                          <td>(10 pontos por Suspensão)</td>
                        </tr>
                        <tr>
                          <td><b>Pontuação (A)</b></td>
                          <td><b>{{ avaliacao.notaFichaFuncional }}</b></td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <div class="row">
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Atrasos:</label>
                    <p>{{ avaliacao.quantidadeAtrasos }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesAtrasos }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Faltas:</label>
                    <p>{{ avaliacao.quantidadeFaltas }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesFaltas }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Repreensões:</label>
                    <p>{{ avaliacao.quantidadeRepreensoes }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesRepreensoes }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Suspensões:</label>
                    <p>{{ avaliacao.quantidadeSuspensoes }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesSuspensoes }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Formação continuada&nbsp;<small
                    >(Preenchido pelo DEGEPAT)</small
                  >
                </h4>
                <div class="row">
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <label>Quantidade de horas cursadas pelo servidor:</label>
                    <p>{{ avaliacao.quantidadeHorasCursadas }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>PONTUAÇÃO (B):</label>
                    <p>{{ avaliacao.notaHorasCursadas }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Avaliação de Desempenho</h4>
                <div>
                  <b>Parâmetros&nbsp;</b>
                  <div>
                    <table
                      class="table table-striped table-condensed hidden-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"><span>Plenamente Insatisfatório</span></th>
                          <th align="left"><span>Insatisfatório</span></th>
                          <th align="left"><span>Regular</span></th>
                          <th align="left"><span>Satisfatório</span></th>
                          <th align="left"><span>Plenamente Satisfatório</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-title="Plenamente Insatisfatório" align="left">
                            (1-2 pontos)
                          </td>
                          <td data-title="Insatisfatório" align="left">
                            (3-4 pontos)
                          </td>
                          <td data-title="Regular" align="left">
                            (5-6 pontos)
                          </td>
                          <td data-title="Satisfatório" align="left">
                            (7-8 pontos)
                          </td>
                          <td data-title="Plenamente Satisfatório" align="left">
                            (9-10 pontos)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table table-striped table-condensed visible-xs"
                    >
                      <tbody>
                        <tr>
                          <td>Plenamente Insatisfatório</td>
                          <td>(1-2 pontos)</td>
                        </tr>
                        <tr>
                          <td>Insatisfatório</td>
                          <td>(3-4 pontos)</td>
                        </tr>
                        <tr>
                          <td>Regular</td>
                          <td>(5-6 pontos)</td>
                        </tr>
                        <tr>
                          <td>Satisfatório</td>
                          <td>(7-8 pontos)</td>
                        </tr>                        
                        <tr>
                          <td>Plenamente Satisfatório</td>
                          <td>(9-10 pontos)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="padding-top: 10px">
                    <table
                      class="table table-striped table-condensed hidden-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"></th>
                          <th align="left">
                          </th>
                          <th align="center" style="min-width: 135px">
                            <span>Avaliador 1 (C)</span>
                          </th>
                          <th align="center" style="min-width: 135px">
                            <span>Avaliador 2 (D)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(nota, index) in notasOrdenadas"
                          :key="nota.id"
                          :class="{ 'has-error': errors.has('name' + index) }"
                        >
                          <td data-title="" align="left">
                            {{ nota.item.codigo }}
                          </td>
                          <td
                            data-title="Indicadores de Desempenho"
                            align="left"
                          >
                            <b>{{ nota.item.titulo }}&nbsp;</b>
                            <esconde-div>{{ nota.item.descricao }}</esconde-div>
                          </td>
                          <td data-title="Avaliador 1 (C)" align="left">
                            <input
                              type="text"
                              size="3"
                              :name="'notaC' + index"
                              :id="'notaC' + index"
                              v-validate="
                                'required|numeric|min_value:1|max_value:10'
                              "
                              data-vv-as="Nota"
                              v-model="nota.notaAvaliador"
                              v-if="habilitaNotasPrimeiroAvaliador"
                            />
                            <span v-else>{{nota.notaAvaliador}}</span>
                            <span
                              v-show="errors.has('notaC' + index)"
                              class="error"
                              >{{ errors.first('notaC' + index) }}</span
                            >
                          </td>
                          <td data-title="Avaliador 2 (D)" align="left">
                            <input
                              type="text"
                              size="3"
                              :name="'notaD' + index"
                              :id="'notaD' + index"
                              v-validate="
                                'required|numeric|min_value:1|max_value:10'
                              "
                              data-vv-as="Nota"
                              v-model="nota.notaSegundoAvaliador"
                              v-if="habilitaNotasSegundoAvaliador"
                            />
                            <span v-else>{{nota.notaSegundoAvaliador}}</span>
                            <span
                              v-show="errors.has('notaD' + index)"
                              class="error"
                              >{{ errors.first('notaD' + index) }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td>
                            <b
                              >TOTAL DE PONTOS DO AVALIADOR (C) E DO AVALIADOR 2 (D):
                            </b>
                          </td>
                          <td style="padding-left: 12px">
                            {{ somaPrimeiroAvaliador }}
                          </td>
                          <td style="padding-left: 12px">
                            {{ somaSegundoAvaliador }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <table
                      class="table table-striped table-condensed visible-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"></th>
                          <th align="left">
                            <span>Indicadores de Desempenho</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(nota, index) in notasOrdenadas"
                          :key="nota.id"
                          :class="{ 'has-error': errors.has('name' + index) }"
                        >
                          <td data-title="" align="left">
                            {{ nota.item.codigo }}
                          </td>
                          <td
                            data-title="Indicadores de Desempenho"
                            align="left"
                          >
                            <b>{{ nota.item.titulo }}&nbsp;</b>
                            <esconde-div>{{ nota.item.descricao }}</esconde-div>
                            <div style="display: flex">
                              <div class="item">
                                <p>Avaliador (C)</p>
                                <input
                                  type="number"
                                  :name="'notaC' + index"
                                  id="notaC"
                                  v-validate="
                                    'required|numeric|min_value:1|max_value:10'
                                  "
                                  data-vv-as="Nota"
                                  v-model="nota.notaAvaliador"
                                  v-if="habilitaNotasPrimeiroAvaliador"
                                />
                                <span v-else>{{ nota.notaAvaliador }}</span>
                                <span
                                  v-show="errors.has('notaC' + index)"
                                  class="error"
                                >
                                  {{ errors.first('notaC' + index) }}</span
                                >
                              </div>
                              <div class="item">
                                <p>Avaliador (D)</p>
                                <input
                                  type="number"
                                  :name="'notaD' + index"
                                  id="notaC"
                                  v-validate="
                                    'required|numeric|min_value:1|max_value:10'
                                  "
                                  data-vv-as="Nota"
                                  v-model="nota.notaSegundoAvaliador"
                                  v-if="habilitaNotasSegundoAvaliador"
                                />
                                <span v-else>{{ nota.notaSegundoAvaliador }}</span>
                                <span
                                  v-show="errors.has('notaD' + index)"
                                  class="error"
                                >
                                  {{ errors.first('notaD' + index) }}</span
                                >
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td>
                            <b>TOTAL DE PONTOS: </b>
                            <div style="display: flex">
                              <div class="item">
                                <p>Avaliador (C)</p>
                                {{ somaPrimeiroAvaliador }}
                              </div>
                              <div class="item">
                                <p>Avaliador (D)</p>
                                {{ somaSegundoAvaliador }}
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>MÉDIA (M) = (C + D) /2:</label>
                      <p>{{ mediaAvaliacoes }}</p>
                    </div>
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>PONTUAÇÃO FINAL (A + B + M):</label>
                      <p>{{ pontuacaoFinal }}</p>
                    </div>
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>Data da Avaliação</label>
                      <p>{{ dataAvaliacao }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Ciência do Servidor Avaliado</h4>
                <div class="row">
                  <div class="col-lg-12">
                    <p style="text-align: justify">
                      Em caso de discordância, o servidor avaliado deverá abrir processo digital 
                      de Recurso de Notas de Avaliação, em até 10 (dez) 
                      dias úteis contados a partir da ciência da nota.
                    </p>
                  </div>
                </div>
                <div
                  class="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8"
                  v-if="avaliacao.aceita == true || avaliacao.aceita == false"
                >
                  <div class="card sub-card sub-card-content">
                    <div class="anuencia">
                      Servidor avaliado
                      <span class="anuencia-resultado">{{
                        avaliacao.aceita ? 'CONCORDA' : 'NÃO CONCORDA'
                      }}</span>
                      com a pontuação final.
                    </div>
                  </div>
                </div>
                <p v-else></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-md-12">
            <botao
              estilo="vazado-verde-esq"
              rotulo="Voltar"
              icone="voltar"
              @clicado="voltar()"
            >
            </botao>
            <botao
              estilo="cheio-verde-dir"
              rotulo="Anuência"
              icone="fa-check fa-lg"
              v-if="mostraFinalizar"
              @clicado="valida('finalizar')"
            >
            </botao>
            <botao
              :estilo="mostraFinalizar ? 'vazado-verde-dir' : 'cheio-verde-dir'"
              rotulo="Salvar"
              icone="fa-floppy-o fa-lg"
              v-if="mostraSalvar"
              @clicado="valida('salvar')"
            >
            </botao>
            <span
              v-tooltip.bottom="
                'Visual. impres. finalizadas com Concordo ou Discordo'
              "
              class="disabled-tooltip"
            >
              <botao
                :estilo="ehAvaliador ? 'vazado-verde-dir' : 'cheio-verde-dir'"
                rotulo="Imprimir"
                icone="imprimir-tabela"
                v-if="mostraImprimir"
                @clicado="imprime(avaliacao.id)"
                :disabled="(avaliacaoFinalizada || ehAvaliador || naoFinalizadoComPeriodoEncerrado) ? false : true"
              >
              </botao>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Avaliacao from '@/domain/avaliacaoEstagioProbatorio';
import Avaliado from '@/domain/avaliado';
import Avaliador from '@/domain/avaliador';
import Botao from '@/components/botao';
import EscondeDiv from '@/components/esconde-div';
import AvaliacaoEstagioProbatorioService from '@/services/avaliacaoEstagioProbatorioService';
import PeriodosEstagioProbatorioService from '@/services/periodosEstagioProbatorioService';
import obtemImpressao from '@/services/obtemImpressao';
import DateHelper from '@/helpers/DateHelper';
import PeriodoAtualHelper from '@/helpers/PeriodoAtualHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import { setTimeout } from 'timers';
import moment from 'moment';

export default {
  name: 'DetalhaAvaliacaoEstagioProbatorio',

  data() {
    return {
      avaliacao: {},
      periodos: {},
      notas: [],
      avaliadorId: this.$route.params.idAvaliador,
      funcionarioId: this.$route.params.idAvaliado,
      mostraParametros: false,
      mostraComprometimento: false,
      mostraDedicacao: false,
      mostraRelacionamento: false,
      mostraAtendimento: false,
      mostraCapacidade: false,
      apiErrors: null,
    };
  },

  computed: {
    cargo() {
      return this.avaliacao.avaliado.cargoReadaptado
        ? this.avaliacao.avaliado.cargoReadaptado
        : this.avaliacao.avaliado.cargoPrincipal;
    },
    cargoChefeImediato() {
      return this.avaliacao.cargoAvaliador
        ? `${this.avaliacao.cargoAvaliador.toUpperCase()} ${
            this.avaliacao.uorAvaliador.sigla
          }`
        : `${this.avaliacao.avaliador.cargoPrincipal} - ${
            this.avaliacao.uorAvaliador.sigla
          }`;
    },
    dataInicioReferencia() {
      return DateHelper.convertDateToPtbr(this.periodos.dataInicioReferencia);
    },
    dataFimReferencia() {
      return DateHelper.convertDateToPtbr(this.periodos.dataFimReferencia);
    },
    notasOrdenadas() {
      return this.avaliacao.notas.sort((a, b) => {
        if (a.item.codigo < b.item.codigo) return -1;
        if (a.item.codigo > b.item.codigo) return 1;
      });
    },
    dataAvaliacao() {
      if (this.avaliacao.dataAvaliacao) {
        return DateHelper.convertDateToPtbr(this.avaliacao.dataAvaliacao);
      }
    },
    peridoAvaliacao() {
      return DateHelper.convertDateToPtbr(this.avaliacao.dataInicioPeriodoAvaliacao)
        + ' a ' +
        DateHelper.convertDateToPtbr(this.avaliacao.dataFimPeriodoAvaliacao) ;
    },
    somaPrimeiroAvaliador() {
      let soma = 0;
      this.avaliacao.notas.forEach(nota =>
          nota.notaAvaliador ? (soma += parseInt(nota.notaAvaliador)) : soma,
      );
      return soma;
    },
    somaSegundoAvaliador() {
      let soma = 0;
      this.avaliacao.notas.forEach(nota =>
        nota.notaSegundoAvaliador ? (soma += parseInt(nota.notaSegundoAvaliador)) : soma,
      );
      return soma;
    },
    mediaAvaliacoes() {
      const somaPrimeiroAvaliador = this.somaPrimeiroAvaliador;
      const somaSegundoAvaliador = this.somaSegundoAvaliador;

      if(!somaPrimeiroAvaliador || !somaSegundoAvaliador) {
        return null;
      }

      return (somaPrimeiroAvaliador + somaSegundoAvaliador) / 2;
    },
    pontuacaoFinal() {
      const notaFichaFuncional = this.avaliacao.notaFichaFuncional;
      const notaHorasCursadas = this.avaliacao.notaHorasCursadas;
      const mediaAvaliacoes = this.mediaAvaliacoes;

      if(!mediaAvaliacoes) {
        return null;
      }

      return (notaFichaFuncional + notaHorasCursadas + mediaAvaliacoes);
    },
    ehAvaliador() {
      return this.ehPrimeiroAvaliador || this.ehSegundoAvaliador;
    },
    ehPrimeiroAvaliador() {
      if (!this.avaliacao.avaliador) return false;
      return !this.ehAvaliado && this.avaliadorId == this.avaliacao.avaliador.id;
    },
    ehSegundoAvaliador() {
      if (!this.avaliacao.segundoAvaliador) return false;
      return !this.ehAvaliado && this.avaliadorId == this.avaliacao.segundoAvaliador.id;
    },
    ehAvaliado() {
      return this.avaliacao.avaliado.id == this.avaliadorId;
    },
    periodoValido() {
      return moment(new Date())
        .isBetween(this.periodos.dataInicioLancamento,
        this.periodos.dataFimLancamento, 'day', '[]');
    },
    naoFinalizadoComPeriodoEncerrado() {
      return this.avaliacao.aceita == null && PeriodoAtualHelper.periodoEncerrado(this.periodos.dataFimLancamento);
    },
    avaliacaoFinalizada() {
      return this.avaliacao.aceita != null;
    },
    habilitaNotasPrimeiroAvaliador() {
      let resultado =
        this.ehPrimeiroAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return resultado;
    },
    habilitaNotasSegundoAvaliador() {
      let resultado =
        this.ehSegundoAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return resultado;
    },
    mostraSalvar() {
      let resultado =
        this.periodoValido && !this.avaliacaoFinalizada && this.ehAvaliador;
      return resultado;
    },
    mostraFinalizar() {
      let resultado =
        this.periodoValido &&
        !this.ehAvaliador &&
        this.foiAvaliado &&
        !this.avaliacaoFinalizada
      return resultado;
    },
    foiAvaliado() {
      return (this.somaPrimeiroAvaliador > 0) && (this.somaSegundoAvaliador > 0);
    },
    mostraImprimir() {
      return (
        !this.periodoValido || this.ehAvaliador || this.avaliacaoFinalizada
      );
    },
  },

  methods: {
    voltar() {
      if (this.ehAvaliador) {
        this.$router.push({ name: 'AvaliadosEstagioProbatorio', params: { params: { id: this.avaliadorId }}});
      } else {
        this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
      }
    },
    valida(metodo) {
      this.$validator.validateAll().then(success => {
        if (success) {
          metodo === 'salvar' ? this.salvar() : this.finalizar();
          return;
        }
        this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    salvar() {
      const sentences = [
        {
          id: 1,
          message: 'Deseja salvar essa avaliação?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          const response = await this.gravaFinalizaAvaliacao(
            this.avaliacao.id,
            this.avaliacao,
            null,
          );

          if(response.status == 200) {
            this.$root.$refs.toastr.s('Avaliação salva', 'Sucesso');
          }

          this.chamaProximaTela();
        },
        title: 'Salvar Avaliação',
      });
    },
    async gravaFinalizaAvaliacao(id, item, aceita) {
      item.aceita = aceita;

      try {
        return await AvaliacaoEstagioProbatorioService.atualiza(id, item);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
        return error;
      }
    },
    finalizar() {
      jQuery('#finalizaModal').modal('show');
    },
    async discorda() {
      const response = await this.gravaFinalizaAvaliacao(
        this.avaliacao.id,
        this.avaliacao,
        false,
      );

      if(response.status == 200) {
        this.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
      }

      jQuery('#finalizaModal').modal('hide');
      this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
    },
    async concorda() {
      const response = await this.gravaFinalizaAvaliacao(
        this.avaliacao.id,
        this.avaliacao,
        true,
      );

      if(response.status == 200) {
        this.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
      }

      jQuery('#finalizaModal').modal('hide');
      this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
    },
    async imprime(id) {
      const endpoint = `avaliacoes-estagio-probatorio/${id}/ficha`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    obtemAvaliacaoENotas() {
      const avaliacoes = JSON.parse(sessionStorage.getItem('periodosEstagioProbatorio'));
      this.avaliacao = avaliacoes.find(
        item => item.avaliado.id == this.funcionarioId,
      );
      this.periodos = this.avaliacao.competencia.periodos[0];
    },
    async obtemAvaliados(funcionarioId, idMes) {
      try {
        const avaliacoes = await PeriodosEstagioProbatorioService.lista(funcionarioId, idMes);
        sessionStorage.setItem('periodosEstagioProbatorio', JSON.stringify(avaliacoes));
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async chamaProximaTela() {
      if (this.ehAvaliador) {
        let avaliadorId = this.avaliacao.avaliador.id;
        await this.obtemAvaliados(avaliadorId, this.avaliacao.competencia.id);
        this.$router.push({ name: 'AvaliadosEstagioProbatorio', params: { id: avaliadorId } });

        return;
      }
      this.$router.push({ name: 'AvaliacaoEstagioProbatorio' });
    },
  },

  created() {
    this.avaliacao = new Avaliacao(new Avaliado(), new Avaliador(), new Avaliador());
    this.obtemAvaliacaoENotas();
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao,
    EscondeDiv,
  },
};
</script>

<style scoped>
input[type='number'] {
  width: 3.2em;
}

.item {
  width: 50%;
}

.item p {
  margin: 5px 0 5px 0;
}

.item input {
  margin-bottom: 4px;
}

.anuencia {
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
  padding: 20px;
}

.anuencia-resultado {
  color: #00615c;
}
</style>



// WEBPACK FOOTER //
// detalha-avaliacao.vue?e34de35c